export default async function(records)
{
	const statusLabel = {
		10: 'Criado', 20: 'Congelado', 30: 'Em contagem',
		40: 'Pronto p/ fechar', 50: 'Fechado', 60: 'Cancelado',
	};
	const statusColor = {
		10: '#64748b', 20: '#2563eb', 30: '#d97706',
		40: '#16a34a', 50: '#6b7280', 60: '#dc2626',
	};
	const typeLabel = {
		position: 'Por posição', product: 'Por produto', import: 'Por planilha',
	};

	const rows = (records || []).map(r => {
		const pct = r.total_items ? Math.round((r.finalized_items / r.total_items) * 100) : 0;
		const color = statusColor[r.status] || '#333';
		const label = statusLabel[r.status] || r.status;
		const created = r.created_on ? r.created_on.substring(0, 10) : '';
		const pending = Math.max(0, (r.total_items || 0) - (r.finalized_items || 0));
		const company = r.company_nick || r.company_name || '';
		return `
		<tr data-id='${JSON.stringify([r.company_id, r.id])}'>
			<td><input type="checkbox"></td>
			<td>${r.id}</td>
			<td>${company}</td>
			<td>${r.name || ''}</td>
			<td>${typeLabel[r.session_type] || r.session_type || ''}</td>
			<td style="color:${color}; font-weight:600;">${label}</td>
			<td>
				<div style="font-weight:600;">${pct}%</div>
				<div class="inv-grid-progress"><span style="width:${pct}%;"></span></div>
				<small style="color:#64748b;">${r.finalized_items || 0}/${r.total_items || 0} finalizados · ${pending} pendentes</small>
			</td>
			<td>${created}</td>
		</tr>`;
	}).join('');

	return `
		<style>
			.view th:nth-child(1) { width:1rem; }
			.view td:nth-child(2) { text-align:right; width:3rem; }
			.view td:nth-child(3) { width:5rem; }
			.view td:nth-child(7) { text-align:center; }
			.view td:nth-child(8) { text-align:center; width:7rem; }
			.inv-grid-progress { height: 7px; background:#e5e7eb; border-radius:999px; overflow:hidden; min-width:7rem; margin:2px auto; }
			.inv-grid-progress span { display:block; height:100%; background:#16a34a; }
			.inv-counts-hint { color:#64748b; font-size:.76rem; margin:4px 0 6px; }
		</style>
		<div class="inv-counts-hint">Para ver as contagens em tela, clique na linha do inventário ou use Operações &gt; Ver contagens / acompanhamento. Empresa no filtro é opcional.</div>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th>#</th>
					<th>Empresa</th>
					<th>Nome</th>
					<th>Tipo</th>
					<th>Status</th>
					<th>Progresso</th>
					<th>Criado em</th>
				</tr>
			</thead>
			<tbody>${rows}</tbody>
		</table>`;
}
